import { GetterTree } from 'vuex';

import { RootState } from '@/store/types';

import { subscribableStore } from './common';
import { WeatherState } from './types';

const getters: GetterTree<WeatherState, RootState> = {
  ...subscribableStore.getters,
};

export default getters;
